import {
    createAction,
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';

import OutputReportService from '../services/OutputReportService';
import IReports from '../types/IReports';
import { LOGOUT } from '../constants/actions/auth.constants';

const NAME = 'Reports';

const getReports = createAsyncThunk(
    `${NAME}/getReports`,
    OutputReportService.getReports,
);

const setDetailLoading = createAction<boolean>(`${NAME}/setDetailLoading`);

type ReportState = {
    list: {
        data: IReports[];
        loading: boolean;
    };
    detail: {
        loading: boolean;
    };
};

const initialState: ReportState = {
    list: {
        data: [],
        loading: false,
    },
    detail: {
        loading: false,
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getReports.pending, (state) => {
            state.list.loading = true;
        });
        builder.addCase(getReports.fulfilled, (state, action) => {
            state.list.loading = false;
            state.list.data = action.payload.data;
        });
        builder.addCase(getReports.rejected, (state) => {
            state.list.loading = false;
        });
        builder.addCase(LOGOUT, (state) => {
            state.list.data = [];
            state.list.loading = false;
            state.detail.loading = false;
        });

        builder.addCase(
            setDetailLoading.type,
            (state: ReportState, action: PayloadAction<boolean>) => {
                state.detail.loading = action.payload;
            },
        );
    },
});

const OutputReportActions = {
    getReports,
    setDetailLoading,
};

export default OutputReportActions;
export const OutputReportReducer = slice.reducer;
